import script from "./PdAmountInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PdAmountInput.vue?vue&type=script&setup=true&lang=js"

import "./PdAmountInput.vue?vue&type=style&index=0&id=63fbef7a&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63fbef7a"]])

export default __exports__